module.exports = __webpack_public_path__ + "static/media/pdf-icon-no-text.b4aeaed5.svg";


//////////////////
// WEBPACK FOOTER
// ./public/images/pdf-icon-no-text.svg
// module id = 1622
// module chunks = 1